import { makeRequest } from './data_utils';

const getUserProfile = (userId) => {
    const endpoint = `api/users/${userId}/profile`;
    return makeRequest(endpoint, 'GET');
};

const getUserInfo = () => {
    const endpoint = `api/users/me`;
    return makeRequest(endpoint, 'GET');
};

const updateProfile = (userId, first_name, last_name, full_name, image_url) => {
    const endpoint = `api/users/${userId}/profile`;
    const body = {
        first_name: first_name,
        last_name: last_name,
        full_name: full_name,
        image_url: image_url
    };
    return makeRequest(endpoint, 'PUT', body);
};

const getGuestToken = (code) => {
    const endpoint = `api/token/${code}`;
    
    // For guest token requests, we need to make an unauthenticated request
    // since the user doesn't have a token yet
    return new Promise((resolve) => {
        const urlhost = window._env_?.REACT_APP_HOST;
        if (!urlhost) {
            console.error('❌ REACT_APP_HOST is not configured in window._env_');
            resolve({ success: false, message: 'API host not configured' });
            return;
        }
        
        const cleanUrlhost = urlhost.replace(/\/$/, '');
        const cleanPath = endpoint.replace(/^\//, '');
        const requestUrl = `${cleanUrlhost}/${cleanPath}`;
        

        
        fetch(requestUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
                        .then(data => {
                    resolve(data);
                })
        .catch(error => {
            console.error('❌ Guest token API error:', error);
            resolve({ success: false, message: error.message || 'Request failed' });
        });
    });
};

const userData = {
    getUserInfo,
    getUserProfile,
    updateProfile,
    getGuestToken
};

export { userData }; 